export const unreachable = <T,>(value: never, fallback: T): T => fallback;
export type SingleValue<T> = { value: T; label: string; key: number };
